import { fetchCachedPublicGet } from "./publicRequest";

const buildQuery = (params = {}) => {
  const query = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""),
  ).toString();
  return query ? `?${query}` : "";
};

export const fetchTrekFeed = (params = {}, options = {}) =>
  fetchCachedPublicGet(`/explore/treks/feed${buildQuery(params)}`, options);

export const fetchTrekDetail = (destinationSlug, trekSlug, options = {}) => {
  const safeDestinationSlug = String(destinationSlug || "").trim();
  const safeTrekSlug = String(trekSlug || "").trim();
  if (!safeTrekSlug) {
    return Promise.reject(new Error("Trek slug missing"));
  }
  const basePath = safeDestinationSlug
    ? `/explore/treks/${safeDestinationSlug}/${safeTrekSlug}`
    : `/explore/treks/${safeTrekSlug}`;
  const requestOptions = { ...options };
  const path = `${basePath}${buildQuery({ view: options.view })}`;
  delete requestOptions.view;
  return fetchCachedPublicGet(path, requestOptions);
};

const trekApi = { fetchTrekFeed, fetchTrekDetail };

export default trekApi;
